import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';

import useQueryVariables from '../../../hooks/useQueryVariables';
import { useSelector } from 'react-redux';
import { listingAliasSelector } from '../../../selectors';
import { ComplianceMessagingContext } from '../../ComplianceMessagingContext';
import { GET_COMPLIANCE_QUERY } from '../../../utils/complianceMessaging';

export default function ComplianceMessagingProvider({ children }) {
  const { applicationId } = useQueryVariables();
  const listingAlias = useSelector(listingAliasSelector);

  const { loading, error, data } = useQuery(GET_COMPLIANCE_QUERY, {
    variables: {
      propertyId: listingAlias,
      applicationId,
    },
  });

  const complianceList = data?.property?.application?.complianceList ?? null;

  const nextCompliance = (complianceList || []).find((compliance) => !compliance.hasBeenAccepted);
  return (
    <ComplianceMessagingContext.Provider
      value={{
        complianceList,
        nextCompliance,
        error,
        isLoading: loading,
      }}
    >
      {children}
    </ComplianceMessagingContext.Provider>
  );
}

ComplianceMessagingProvider.propTypes = {
  children: PropTypes.node,
};
